<div class="modal-header"><h2 class="modal-title">Email Message</h2></div>
<div class="modal-body d-flex">
  @if (emailMessage) {

    <!-- First column -->
    <div class="col-sm-8">
      @if (!hideCommittee){
        <div class="d-flex" style="margin-bottom: 15px">
          <div>
            <label class="mt-2 me-2">Send To</label>
          </div>
          <dx-select-box
            [(value)]="selectedCommitteeId"
            [items]="committees"
            [valueExpr]="'id'"
            [displayExpr]="'name'"
            (onSelectionChanged)="selectionChanged($event)"
            [disabled]="mode !== 'executive' && mode !== 'finance'"
          ></dx-select-box>
        </div>

        @if (members) {
          <div class="widget-content user">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Person</th>
                  <th>Email</th>
                  <th>Cell</th>
                </tr>
              </thead>
              <tbody>
                <tr [hidden]="members.length > 0">
                  <td colspan="9">No items</td>
                </tr>
                @for (member of members; track member) {
                  <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="members.length === 0">
                    <td style="padding: 6px">{{ member.person.displayName }}</td>
                    <td style="padding: 6px">{{ member.person.email }}</td>
                    <td style="padding: 6px">{{ member.person.cellPhone }}</td>
                    <td style="padding: 6px"><i class="fa fa-times" (click)="remove(member.personId)"></i></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }

      <dx-form [formData]="emailMessage" validationGroup="emailDialogValidationGroup">
        <dxi-item dataField="to" [isRequired]="true" [editorOptions]="{ readOnly: true }"> </dxi-item>

        <dxi-item [label]="{ text: 'CC' }">
          <div *dxTemplate>
            <div class="d-flex">
              <dx-text-box class="flex-grow-1" [(value)]="emailMessage.cc"></dx-text-box>
              <button class="btn btn-sm btn-primary ms-2" [style]="{ width: '80px' }" (click)="addCouncilClerk()">Add Clerk</button>
            </div>
          </div>
        </dxi-item>
        <dxi-item dataField="subject"> </dxi-item>
        <dxi-item dataField="body" editorType="dxTextArea" [editorOptions]="{ height: 250 }"> </dxi-item>
        @if (entity) {
          <dxi-item [label]="{ text: 'Report' }">
            <div *dxTemplate style="margin-top: 10px">
              <a [routerLink]="" (click)="openReport(this.mode)">View Attached File</a>
            </div>
          </dxi-item>
        }
      </dx-form>
    </div>

    <!-- Second column -->
    @if (!hideAttachments) {
      <div class="col-sm-4">
        @if (attachments) {
          <div class="mt-2 widget-content user">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Attachment</th>
                </tr>
              </thead>
              <tbody>
                <tr [hidden]="attachments.length > 0">
                  <td colspan="9">No attachments</td>
                </tr>
                @for (attachment of attachments; track attachment) {
                  <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="attachments.length === 0">
                    <td style="padding: 6px">{{ attachment.name }}</td>
                    <td style="padding: 6px"><i class="fa fa-times" (click)="removeAttachment(attachment.id)"></i></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
      } }
    </div>

    <div class="modal-footer">
      @if (!hideAttachments) {
        <button class="btn btn-success me-2" (click)="addMinutes()">Add Attachments</button>
      }
      <button class="btn btn-success" [disabled]="processing" (click)="save()">Send</button>
      <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    </div>
